<template>
    <div>
        <zipcode-input
            :inputId="formId + '_zipcode'"
            :inputLbl="lblShipping.zipcode"
            :inputMinLength="5"
            :inputMaxLength="5"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="isShowErrorLbl"
            :errorInfo="zipcodeError"
            v-model="address.zipcode"
            class="mb-3"
            @onZipcodeChange="onZipcodeChange()"
        ></zipcode-input>
        <div class="wrap-input mb-3">
            <div
                :class="{
                    'input-box-error':
                        !isFirstSave &&
                        isShowErrorLbl &&
                        !provinceError.isValid,
                }"
            >
                <label class="label">จังหวัด</label>
                <b-dropdown
                    v-bind:class="{
                        addressdropdownactive: address.districtName,
                        addressdropdowninactive: !address.districtName,
                    }"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_province'"
                    :text="
                        address.provinceName || lblShipping.province.placeholder
                    "
                >
                    <b-dropdown-item :disabled="true">
                        {{ lblShipping.province.placeholder }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(province, index) in arrFilteredProvince"
                        :key="index"
                        @click="selectProvince(province)"
                    >
                        {{
                            locale == 1033
                                ? province.provinceNameEN
                                : province.provinceName
                        }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="dash"></div>
            <div
                class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !provinceError.isValid"
            >
                {{ provinceError.msg }}
            </div>
        </div>
        <div class="wrap-input mb-3">
            <div
                :class="{
                    'input-box-error':
                        !isFirstSave &&
                        isShowErrorLbl &&
                        !districtError.isValid,
                }"
            >
                <label class="label">เขต/อำเภอ</label>
                <b-dropdown
                    v-bind:class="{
                        addressdropdownactive: address.districtName,
                        addressdropdowninactive: !address.districtName,
                    }"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_district'"
                    :text="
                        address.districtName || lblShipping.district.placeholder
                    "
                >
                    <b-dropdown-item :disabled="true">
                        {{ lblShipping.district.placeholder }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(district, index) in arrFilteredDistrict"
                        :key="index"
                        @click="selectDistrict(district)"
                    >
                        {{
                            locale == 1033
                                ? district.districtNameEN
                                : district.districtName
                        }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="dash"></div>
            <div
                class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !districtError.isValid"
            >
                {{ districtError.msg }}
            </div>
        </div>
        <div class="wrap-input mb-3">
            <div
                :class="{
                    'input-box-error':
                        !isFirstSave &&
                        isShowErrorLbl &&
                        !subDistrictError.isValid,
                }"
            >
                <label class="label"
                    >แขวง/ตำบล
                    <span class="d-none">{{
                        this.nameSubDistrict
                    }}</span></label
                >
                <b-dropdown
                    v-bind:class="{
                        addressdropdownactive: address.districtName,
                        addressdropdowninactive: !address.districtName,
                    }"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_subdistrict'"
                    :text="
                        address.subDistrictName ||
                        lblShipping.subdistrict.placeholder
                    "
                >
                    <b-dropdown-item :disabled="true">
                        {{ lblShipping.subdistrict.placeholder }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(subdistrict, index) in arrFilteredSubDistrict"
                        :key="index"
                        @click="selectSubDistrict(subdistrict)"
                    >
                        {{
                            locale == 1033
                                ? subdistrict.subdistrictNameEN
                                : subdistrict.subdistrictName
                        }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="dash"></div>
            <div
                class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !subDistrictError.isValid"
            >
                {{ subDistrictError.msg }}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import BzbsAddress from "@/core/Address/service/BzbsAddress.js";
import Locale from "@/helper/locale/locale.js";
import ZipcodeInput from "@/components/Input/Zipcode.vue";
/**
 * @property {object} address (required) Address data model.
 * @property {string} formId (optional) Text for id.
 * @property {object} lblShipping (required) Text for component.
 * @property {object} isFirstSave (required) Show/Hide Error.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide error label under input
 * @property {object} zipcodeError (required) Validate status.
 * @property {object} provinceError (required) Validate status.
 * @property {object} districtError (required) Validate status.
 * @property {object} subDistrictError (required) Validate status.
 *
 * //@property {object} busModal (required) Control modal.
 */
export default {
    name: "FormAddressDropdown",
    components: {
        ZipcodeInput,
    },
    props: {
        lblShipping: Object,
        formId: String,
        address: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        zipcodeError: Object,
        provinceError: Object,
        districtError: Object,
        subDistrictError: Object,

        // busModel: Object
    },
    data: function () {
        return {
            locale: Locale.getLocaleCode(),
            arrProvince: [],
            arrDistrict: [],
            arrSubDistrict: [],
            arrFilteredProvince: [],
            arrFilteredDistrict: [],
            arrFilteredSubDistrict: [],
            nameSubDistrict: "",
        };
    },
    mounted: function () {
        //Validate zipcode and Setup select field.
        if (!this.address) return;
        if (Vue.validator.validateZipCode(this.address.zipcode)) {
            this.onZipcodeChange();
        }

        this.validateSelect();
    },
    methods: {
        //Event
        selectProvince: function (province) {
            this.$emit("input");
            if (!province) return;

            this.filterDistrictByProvince(province);
        },
        selectDistrict: function (district) {
            this.$emit("input");
            if (!district) return;

            this.filterSubDistrictByDistrict(district);
        },
        selectSubDistrict: function (subdistrict) {
            this.$emit("input");
            if (!subdistrict) return;

            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName =
                this.locale == 1033
                    ? subdistrict.subdistrictNameEN
                    : subdistrict.subdistrictName;
            this.nameSubDistrict = subdistrict.subdistrictName;
        },
        onZipcodeChange: function (isInit = false) {
            this.$emit("input");
            if (Util.validateZipCode(this.address.zipcode)) {
                BzbsAddress.apiGetProvinceFilterByZipcode(
                    this.address.zipcode
                ).subscribe(
                    (data) => {
                        //Reset array.
                        this.resetArrAddress();
                        // check not exists zipcode validation from return lists
                        if (data == null) {
                            this.zipcodeError.isValid = false;
                            this.zipcodeError.msg =
                                this.lblShipping.zipcode.invalid;
                        } else {
                            //Setup address array.
                            this.arrProvince = data.listProvince;
                            this.arrDistrict = data.listDistrict;
                            this.arrSubDistrict = data.listSubDistrict;
                            this.initialAddressDDL(isInit);
                        }
                    },
                    (err) => {
                        console.log(err);
                    }
                );
            } else {
                this.resetSelectValue();
                this.resetArrAddress();
                this.validateSelect();
            }
        },
        //Method
        initialAddressDDL: function () {
            if (this.arrProvince.length === 0) return;

            //Setup province data.
            // var self = this;
            var province;
            if (!this.address.ProvinceCode) {
                province = this.arrProvince[0];
            } else {
                // province = this.arrProvince.filter(function (item) {
                //     return (item.provinceCode == self.address.provinceCode);
                // });
                province = this.arrProvince.find((item) => {
                    return item.provinceCode == this.address.ProvinceCode;
                });
                if (!province) {
                    province = this.arrProvince[0];
                }
            }
            this.arrFilteredProvince.push.apply(
                this.arrFilteredProvince,
                this.arrProvince
            );

            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName =
                this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;

            this.filterDistrictByProvince(province);
        },
        resetSelectValue: function () {
            this.address.provinceCode = null;
            this.address.districtCode = null;
            this.address.subDistrictCode = null;
            this.address.provinceName = "";
            this.address.districtName = "";
            this.address.subDistrictName = "";
        },
        resetArrAddress: function () {
            this.arrProvince.length = 0;
            this.arrDistrict.length = 0;
            this.arrSubDistrict.length = 0;
            this.arrFilteredProvince.length = 0;
            this.arrFilteredDistrict.length = 0;
            this.arrFilteredSubDistrict.length = 0;
        },
        validateSelect: function () {
            if (this.address.provinceCode) {
                this.provinceError.isValid = true;
                this.provinceError.msg = "";
            } else {
                this.provinceError.isValid = false;
                this.provinceError.msg = this.lblShipping.province.required;
            }

            if (this.address.districtCode) {
                this.districtError.isValid = true;
                this.districtError.msg = "";
            } else {
                this.districtError.isValid = false;
                this.districtError.msg = this.lblShipping.district.required;
            }

            if (this.address.subDistrictCode) {
                this.subDistrictError.isValid = true;
                this.subDistrictError.msg = "";
            } else {
                this.subDistrictError.isValid = false;
                this.subDistrictError.msg =
                    this.lblShipping.subdistrict.required;
            }
        },
        filterDistrictByProvince: function (province) {
            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName =
                this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;
            //Setup district data.
            var allfilteredDistrict = this.arrDistrict.filter(function (item) {
                return item.provinceCode == province.provinceCode;
            });
            // this.arrFilteredDistrict.push.apply(this.arrFilteredDistrict, allfilteredDistrict);
            this.arrFilteredDistrict = allfilteredDistrict;

            //Set selected item.
            // var self = this;
            var district;
            var filteredByDistrictCode;
            if (!this.address.StreetDistrict) {
                district = allfilteredDistrict[0];
            } else {
                filteredByDistrictCode = this.arrFilteredDistrict.filter(
                    (item) => {
                        return item.districtName == this.address.StreetDistrict;
                    }
                );

                district =
                    filteredByDistrictCode && filteredByDistrictCode.length > 0
                        ? filteredByDistrictCode[0]
                        : allfilteredDistrict[0];
            }

            //Filter subdistrict.
            this.filterSubDistrictByDistrict(district);
        },
        filterSubDistrictByDistrict: function (district) {
            //Fill data.
            this.address.districtCode = district.districtCode;
            this.address.districtName =
                this.locale == 1033
                    ? district.districtNameEN
                    : district.districtName;
            //Setup subdistrict data.
            var allfilteredSubDistrict = this.arrSubDistrict.filter(function (
                item
            ) {
                return item.districtCode == district.districtCode;
            });
            this.arrFilteredSubDistrict = allfilteredSubDistrict;
            // this.arrFilteredSubDistrict.push.apply(this.arrFilteredSubDistrict, allfilteredSubDistrict);

            //Set selected item.
            // var self = this;
            var subdistrict;
            var filteredBySubDistrictCode;
            if (!this.address.StreetSubDistrict) {
                subdistrict = allfilteredSubDistrict[0];
            } else {
                filteredBySubDistrictCode = this.arrFilteredSubDistrict.filter(
                    (item) => {
                        return (
                            item.subdistrictName ==
                            this.address.StreetSubDistrict
                        );
                    }
                );

                subdistrict =
                    filteredBySubDistrictCode &&
                    filteredBySubDistrictCode.length > 0
                        ? filteredBySubDistrictCode[0]
                        : allfilteredSubDistrict[0];
            }

            //Fill data.
            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName =
                this.locale == 1033
                    ? subdistrict.subdistrictNameEN
                    : subdistrict.subdistrictName;

            this.validateSelect();
            this.$emit("input");
        },
    },
};
</script>
<style lang="scss">
.addressdropdownactive {
    color: #000;
    border: none;
    border-radius: 5px;
    width: 100%;
    background-color: transparent;
    background-image: url("../../assets/other/white_dropdown.png");
    background-repeat: no-repeat;
    background-size: 14px;
    background-position-x: calc(100% - 10px);
    background-position-y: 15px;

    &:focus {
        box-shadow: none;
        outline: none;
    }
    &.btn:focus {
        box-shadow: none;
        outline: none;
    }
    &::after {
        display: none;
    }
    &.btn:hover {
        color: #000;
    }
    .dropdown-toggle::after {
        display: none;
    }
}
.addressdropdowninactive {
    border: none;
    border-radius: 5px;
    width: 100%;
    background-color: transparent;
    background-image: url("../../assets/other/white_dropdown.png");
    background-repeat: no-repeat;
    background-size: 14px;
    background-position-x: calc(100% - 10px);
    background-position-y: 15px;

    &:focus {
        box-shadow: none;
        outline: none;
    }
    &::after {
        display: none;
    }
    &.btn:hover {
        color: #000;
    }
    .dropdown-toggle::after {
        display: none;
    }
}
</style>
<style lang="scss" scoped>
.label {
    font-family: "PromptRegular";
    font-size: 17px;
}
select::-ms-expand {
    display: none;
}
::v-deep .dash {
    height: 2px;
    width: 100%;
    background-image: linear-gradient(
        to right,
        #6f5948 0%,
        #6f5948 50%,
        transparent 50%
    );
    background-size: 20px 2px;
    background-repeat: repeat-x;
}
::v-deep .btn-ddl-input {
    font-size: 1rem;
    color: #6f5948 !important;
}
::v-deep .ddl-menu.dropdown-menu {
    color: #fff;
    background: white;
    max-height: 300px;
    overflow-y: auto;
    width: 100%;
}
</style>
